import { type AsyncState, Status } from '@essent/common';
import type { PostAdviceV1Response } from '@integration/api-client/feh';
import { createReducer, on } from '@ngrx/store';
import { FehApiActions } from '@feh/shared-api';

import { initializeGeneralAdviceForm } from '../actions/general-advice-form.actions';

export const generalAdviceFormSelectorKey = 'general-advice-form';

export type GeneralAdviceFormSubmitState = AsyncState<PostAdviceV1Response>;

export interface GeneralAdviceFormState {
  submitState: GeneralAdviceFormSubmitState;
  thankYouPageLink: string | null;
  actionId: string;
}

export const initialGeneralAdviceFormState: GeneralAdviceFormState = {
  submitState: { status: Status.IDLE },
  thankYouPageLink: null,
  actionId: generalAdviceFormSelectorKey,
};

function updateOrIgnore<T>(
  actionId: unknown,
  formActionId: string,
  oldState: T,
  newState: T
): T {
  return actionId === formActionId ? newState : oldState;
}

const adviceApi = FehApiActions.postAdviceV1;
const productApi = FehApiActions.postProductadviceV1;

export const generalAdviceFormReducer = createReducer(
  initialGeneralAdviceFormState,
  on(adviceApi.requestAction, productApi.requestAction, (state, { actionId }) =>
    updateOrIgnore(actionId, state.actionId, state, {
      ...state,
      submitState: { status: Status.PENDING },
    })
  ),
  on(adviceApi.successAction, productApi.successAction, (state, { actionId }) =>
    updateOrIgnore(actionId, state.actionId, state, {
      ...state,
      submitState: { status: Status.SUCCESS },
    })
  ),
  on(
    adviceApi.errorAction,
    productApi.errorAction,
    (state, { actionId, payload }) =>
      updateOrIgnore(actionId, state.actionId, state, {
        ...state,
        submitState: { status: Status.ERROR, error: payload },
      })
  ),
  on(
    initializeGeneralAdviceForm,
    (state, { actionId, thankYouPageLink = null }) => {
      return {
        ...state,
        actionId,
        thankYouPageLink,
        submitState: { status: Status.IDLE },
      };
    }
  )
);
